// Polyfills for Node.js APIs used in the browser
import { Buffer } from 'buffer';
import * as util from 'util';

// Make Buffer available globally
if (typeof window !== 'undefined') {
  (window as any).Buffer = Buffer;
}
if (typeof global !== 'undefined') {
  (global as any).Buffer = Buffer;
}
if (typeof globalThis !== 'undefined') {
  (globalThis as any).Buffer = Buffer;
}

// Make util available globally
if (typeof window !== 'undefined') {
  (window as any).util = util;
}
if (typeof global !== 'undefined') {
  (global as any).util = util;
}
if (typeof globalThis !== 'undefined') {
  (globalThis as any).util = util;
}

export { Buffer, util };
